module.exports = __webpack_public_path__ + "media/src/images/partners/rwth-704b5bbaf271bcbce31326ebd067b1e0.jpg";